import AxiosInstance from '../helpers/axiosInstance';

const API_URL = process.env.REACT_APP_API_BASE_URL;

const login = async (username: string, password: string) => {
  const response = await AxiosInstance()
    .post(API_URL + "/auth/login", {
      username,
      password,
    });
  return response;
};

const getUserInfo = (username: string | null): Promise<any | null> => {
  return AxiosInstance()
    .post(API_URL + "/auth/getuser", {
      username
    })
    .then((response) => {
      return response.data;
    });
};

const authService = {
  login,
  getUserInfo,
};

export default authService;